import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import SearchCustomerComponent from 'components/customer/SearchCustomerComponent'

const styles = theme => ({})

class LockerModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    locker: PropTypes.object,
    updateLocker: PropTypes.func,
    createLocker: PropTypes.func,
    lockerNames: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    lockerNames: []
  }
  state = {
    locker: {
      name: '',
      available: true,
      customer: void 0,
      expirationDate: void 0
    },
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    const { locker } = nextState
    const lockerProps = this.props.locker
    let isValid = true
    let errors = {}
    if (
      !lockerProps &&
      this.props.lockerNames.includes(_.lowerCase(locker.name))
    ) {
      isValid = false
      errors.name = 'Un autre casier existe déjà avec ce nom'
    }
    if (!locker.available && !locker.expirationDate) {
      isValid = false
      errors.expirationDate = "Vous devez choisir une date d'expiration"
    }
    if (lockerProps && isValid) {
      isValid = !_.isEqual(lockerProps, locker)
    }
    this.setState({ ...nextState, isValid, errors })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      locker: { ...this.state.locker, [name]: value }
    })
  }
  handleAvailableChange = e => {
    const value = e.target.checked
    if (!value) {
      this.updateState({
        ...this.state,
        locker: {
          ...this.state.locker,
          available: value,
          expirationDate: void 0
        }
      })
    } else {
      this.updateState({
        ...this.state,
        locker: {
          ...this.state.locker,
          available: value,
          customer: void 0,
          expirationDate: void 0
        }
      })
    }
  }
  handleOnCreate = () => {
    const { locker } = this.state
    this.props.createLocker(locker)
  }
  handleOnUpdate = () => {
    const { locker } = this.state
    this.props.updateLocker(this.props.locker, locker)
  }
  availableSwitch = classes => {
    const { locker } = this.state
    return (
      <FormControlLabel
        control={
          <Switch
            checked={locker.available}
            onChange={this.handleAvailableChange}
            value="checker"
            color="primary"
          />
        }
        label="Disponible"
      />
    )
  }
  componentDidMount() {
    const { locker } = this.props
    let nextState = { ...this.state }
    if (locker) {
      nextState = { locker: { ...locker } }
    }

    this.updateState(nextState)
  }
  render() {
    const { classes } = this.props
    const { errors, isValid, locker } = this.state
    const isCreate = !this.props.locker
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter un casier' : `Editer casier ${locker.name}`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="name"
                error={!!errors.name}
                helperText={errors.name || null}
                required
                label="Nom"
                onChange={this.handleChange('name')}
                value={locker.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              {this.availableSwitch(classes)}
            </Grid>
            {!locker.available && (
              <Grid item xs={12} sm={12} md={10}>
                <SearchCustomerComponent
                  selectedCustomer={locker.customer}
                  onSelection={this.handleChange('customer')}
                />
              </Grid>
            )}
            {!locker.available && (
              <Grid item xs={12} sm={12} md={10}>
                <TextField
                  id="expiration"
                  required
                  error={!!errors.expirationDate}
                  helperText={errors.expirationDate || null}
                  label="Expiration"
                  onChange={this.handleChange('expirationDate')}
                  value={locker.expirationDate || moment().format('YYYY-MM-DD')}
                  type="date"
                  fullWidth
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(LockerModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Lockers/components/LockerModal.js